/**
 * Cambia el header a fondo Burdeos cuando una sección marcada
 * (.tk-section, .sm-section) está detrás de la franja del header.
 */
(function () {
  const header = document.getElementById('header-component');
  if (!header) return;

  const sections = document.querySelectorAll('.tk-section, .sm-section');
  if (!sections.length) return;

  const activeSections = new Set();
  let observer;
  let resizeTimeout;

  function updateState() {
    header.classList.toggle('header--burdeos', activeSections.size > 0);
  }

  function createObserver() {
    if (observer) observer.disconnect();
    activeSections.clear();

    const headerHeight = header.offsetHeight || 80;
    const rootMarginBottom = Math.max(window.innerHeight - headerHeight, 0);

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            activeSections.add(entry.target);
          } else {
            activeSections.delete(entry.target);
          }
        });
        updateState();
      },
      { root: null, rootMargin: `0px 0px -${rootMarginBottom}px 0px`, threshold: 0 }
    );

    sections.forEach((section) => observer.observe(section));
  }

  createObserver();

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(createObserver, 150);
  });
})();
